module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAACXBIWXMAABCbAAAQmwF0iZxLAAAA3UlEQVRYhe2X0Q3CMAxEz4h/MgKjdCQ2IGzASB2hIzACTHCofLW1VDtthKLKT/LPNU5OSW0lQhItcWrKTRhycN6UJZIA3JQ+5wnyrVSL8acuCiARGDimrsfwG1s4vxJmAWRj0S2R1TqTiCqzaK4x+qpMJCttC6Q5j2+HROpsIylKW3CIxvhQyjr31a8Lyo/Mse17cqMPWYQhizBkEYYswpBFGLI4wPVjz+1R5ArypfTpEOf1Y3zwXZRexgdksjK8R2a9UqvN4X91iHQAOqX76EH2dQ39iSh7i7YMAfgCzXjko0DfPRkAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon_delete.png
// module id = IUgn
// module chunks = 4